import qs from 'qs'
import React from 'react'
import Page from '../../components/page/Page'
import { PFPView } from '../../components/pfpview/PFPView'
import config from '../../config.json'
import { BreadcrumbItem, Breadcrumbs } from '@nextui-org/react'
import { useTranslation } from 'react-i18next'

const CollectionPage = (props) => {
    const { t } = useTranslation('common')
    return (
        <Page
            id={'CollectionPage'}
            title={config.titles.pfps}
            description={config.descriptions.pfps}
            banners={false}
            {...props}
            pageTitle={t('pages.pfp_ranking')}
            pageSubtitle={t('pages.discover_rarest_pfps')}
            breadcrumbs={[
                {
                    title: 'Home',
                    link: '/',
                },
                {
                    title: 'Ranking',
                    link: '/pfps',
                },
            ]}
        >
            <PFPView {...props} page={'PFPPage'} />
        </Page>
    )
}

CollectionPage.getInitialProps = async (ctx) => {
    const c = ctx.query.collection

    const paths = ctx.asPath.split('/')

    return qs.parse(paths[paths.length - 1].replace(c + '?', ''))
}

export default CollectionPage
